import React from 'react';
import { isEmpty } from 'lodash/lang';

import { COMMENT_FORM_QUESTION_ID } from '../../../../../../constants/protocolConstant';
import { COMMENT, COMMENTS, COMMENTS_DOMAIN_CODE } from '../reviewConstants';

export function isCommentAnswer(answer) {
  return answer.itemGroupQuestionId === COMMENT_FORM_QUESTION_ID;
}

export function isAnswerAffectedByConditionalLogic(answer) {
  return answer.type === 'NO_SENSE';
}

export function resolveAnswerNoPopulatedReason(answer) {
  const answerType = answer?.type;
  if (answerType === 'NOT_ASKED') {
    return `Not Asked: ${answer.emptyReason}`;
  }
  if (answerType === 'UNAVAILABLE') {
    return `Unavailable: ${answer.emptyReason}`;
  }
  if (answerType === 'NO_SENSE') {
    return 'Unavailable';
  }
  if (answerType === 'EMPTY') {
    return '';
  }

  return '--';
}

export function isAnswerPopulated(answer) {
  return answer?.type === 'VALUE';
}

export function getItemGroupType({ domainCode, patientItemGroupType }) {
  if (domainCode === COMMENTS_DOMAIN_CODE) {
    return COMMENTS;
  }
  return patientItemGroupType;
}

export function openCommentModalLinkContent(commentAnswer) {
  if (!isEmpty(commentAnswer?.stringValue)) {
    return COMMENT;
  }
  return null;
}

export function getAnswerHighlightStyleClassByAnswerAndReviewType(answer) {
  if (answer?.highlighted) {
    return { className: 'answer-required-attention-bg' };
  }
  return {};
}

export function generateResearchConnectStatus(response) {
  if (!isEmpty(response)) {
    return response.reduce(
      (sum, item) => (
        <>
          {sum} <br /> {item.platformName} : {item.status}
        </>
      ),
      <>EDC send status</>
    );
  }
}
